export default interface Address {
  CountryId: number;
  CountryName?: string;
  Street1: string;
  Street2: string;
  City: string;
  StateCode: string;
  PostalCode: string;
}

export type AddressFieldType = keyof Address;

export const names: { [key in AddressFieldType]: keyof Address } = {
  CountryId: 'CountryId',
  CountryName: 'CountryName',
  Street1: 'Street1',
  Street2: 'Street2',
  City: 'City',
  StateCode: 'StateCode',
  PostalCode: 'PostalCode',
};
